module.exports = __webpack_public_path__ + "img/gaming-pad-02.a2862a87.svg";